import moment from 'moment/moment';
import InstallersApiService from '../services/api/installers';
import { enqueueNotification } from './notifications';

export const OPEN_DIBS = 'OPEN_DIBS';
export const RESET_DIBS_OPENER = 'RESET_DIBS_OPENER';

export const FETCH_UNSTABLE_VERSION_USAGE_DETECTED_REQUEST =
  'FETCH_UNSTABLE_VERSION_USAGE_DETECTED_REQUEST';
export const FETCH_UNSTABLE_VERSION_USAGE_DETECTED_SUCCESS =
  'FETCH_UNSTABLE_VERSION_USAGE_DETECTED_SUCCESS';

const INITIAL_STATE = {
  patient: null,
  app: null,
  fileId: null,
  unstableVersionUsageDetector: {
    fetching: false,
    fetched: false,
    organizationId: null,
    detected: false,
    installer: null
  }
};

export default function dibsOpener(state = INITIAL_STATE, action) {
  switch (action.type) {
    case OPEN_DIBS:
      return {
        ...state,
        patient: action.payload.patient,
        app: action.payload.app,
        fileId: action.payload.fileId
      };
    case RESET_DIBS_OPENER:
      return {
        ...state,
        patient: null,
        app: null,
        fileId: null
      };
    case FETCH_UNSTABLE_VERSION_USAGE_DETECTED_REQUEST: {
      return {
        ...state,
        unstableVersionUsageDetector: {
          ...state.unstableVersionUsageDetector,
          organizationId: action.payload.organizationId,
          fetching: true
        }
      };
    }
    case FETCH_UNSTABLE_VERSION_USAGE_DETECTED_SUCCESS: {
      return {
        ...state,
        unstableVersionUsageDetector: {
          organizationId: action.payload.organization_id,
          detected: action.payload.detected,
          fetched: true,
          installer: action.payload.installer,
          fetching: false
        }
      };
    }
    default:
      return state;
  }
}

export function openDibs(app, patient, fileId) {
  return dispatch => {
    dispatch({
      type: OPEN_DIBS,
      payload: { patient, app, fileId }
    });
  };
}

export function resetDibsOpener() {
  return dispatch => {
    dispatch({
      type: RESET_DIBS_OPENER
    });
  };
}

export function checkUnstableVersionUsage(organizationId) {
  return dispatch => {
    const api = new InstallersApiService();

    dispatch({
      type: FETCH_UNSTABLE_VERSION_USAGE_DETECTED_REQUEST,
      payload: { organizationId }
    });

    return api
      .checkUnsatableVersionUsage(organizationId)
      .then(response => {
        dispatch({
          type: FETCH_UNSTABLE_VERSION_USAGE_DETECTED_SUCCESS,
          payload: {
            detected: response.data.detected,
            installer: {
              version: response.data.latest_installer?.version,
              downloadUrl: response.data.latest_installer?.download_url
            },
            organization_id: organizationId
          }
        });
      })
      .catch(error => {
        dispatch(enqueueNotification('error', error.message));
      });
  };
}

const LAST_WARNED_AT = 'UNSTABLE_INSTALLER_USAGE_WARNED_AT';

export function unstableVersionUsageWarned() {
  localStorage.setItem(LAST_WARNED_AT, moment().format('YYYY-MM-DD'));
}

export function recentlyWarned() {
  const lastWarnedAt = localStorage.getItem(LAST_WARNED_AT);
  return lastWarnedAt === moment().format('YYYY-MM-DD');
}
